import {
  CONTENTSTACK_CV_TYPE_TO_CUSTOM_NAME_TYPE,
  CUSTOM_MAP_MAINTAIN_OLD_CV_MODEL_QUERY,
} from '@/const/service/maintenance-list/cv';
import { getParsedData } from '@/contents/useMaintenanceList';
import type {
  ContentstackCvMaintenanceOptionResponse,
  MaintenanceOptionGroupedItem,
} from '@/types/services/contentstack/services/maintenance-service';

export const getCvFirstOptionUniqueKey = (
  item: ContentstackCvMaintenanceOptionResponse
) => {
  return item?.series_marketing_model_name;
};

export const getCvFirstOptionLabel = (
  item?: ContentstackCvMaintenanceOptionResponse
) => item?.series_marketing_model_name;

const MAP_FIRST_OPTIONS_ORDER = {
  'รถบรรทุก 4 ล้อ': 0,
  'รถ 6 ล้อขนาดกลาง': 1,
  'รถ 6 ล้อ ขนาดกลาง': 1,
  'รถ 6 ล้อ ขนาดใหญ่': 2,
  'รถ 10 ล้อ เพลาเดียว': 3,
  'รถ 10 ล้อ 2 เพลา': 4,
  'รถ 12 ล้อ': 5,
  หัวลาก: 6,
  'รถผสมปูน (Mixer)': 7,
  'มินิบัส แชสชีส์': 8,
  'มินิบัส แชสซีส์': 8,
};
const MAP_FIRST_OPTION_LABEL = {
  'รถ 6 ล้อขนาดกลาง': 'รถ 6 ล้อ ขนาดกลาง',
  'มินิบัส แชสชีส์': 'มินิบัส แชสซีส์',
};
export const getCvOrderedFirstOptions = (
  options: MaintenanceOptionGroupedItem[]
) => {
  const ordered = options
    .slice()
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    .sort(
      (a, b) => MAP_FIRST_OPTIONS_ORDER[a.key] - MAP_FIRST_OPTIONS_ORDER[b.key]
    );
  return ordered.map((item) => {
    return {
      ...item,
      label: MAP_FIRST_OPTION_LABEL[item?.key] ?? item?.label,
    };
  });
};

export const getCvOrderedSecondOptions = (
  options: ContentstackCvMaintenanceOptionResponse[]
) => {
  return options.sort((a, b) => b.model_year_begin - a.model_year_begin);
};
export const getCvSecondOptionLabel = (
  item?: ContentstackCvMaintenanceOptionResponse
) => item?.vehicle_name;
export const getCvSecondOptionUniqueKey = (
  item: ContentstackCvMaintenanceOptionResponse
) => {
  return getParsedData(item?.vehicle_name);
};

export const getCvThirdOptionLabel = (
  item: ContentstackCvMaintenanceOptionResponse
) => item?.marketing_model_year_begin_and_end;

export const getCvThirdOptionUniqueKey = (
  item: ContentstackCvMaintenanceOptionResponse
) => `${item?.model_year_begin}`;

export const getCvServiceMaintenancePageUrlFormat = (
  item?: ContentstackCvMaintenanceOptionResponse
) =>
  item
    ? `${
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        CONTENTSTACK_CV_TYPE_TO_CUSTOM_NAME_TYPE[
          getCvFirstOptionUniqueKey(item)
        ]
      }_${getCvSecondOptionUniqueKey(item)}_${getCvThirdOptionUniqueKey(item)}`
    : '';

// type=truck-tractor&model=gxz-the-rock&year=2022-present
export const getMaintainCvRedirectServiceMaintenancePageUrlFormat = (data: {
  type: string;
  model: string;
  year: string;
}) => {
  const startYear = data.year.split('-')[0];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (CUSTOM_MAP_MAINTAIN_OLD_CV_MODEL_QUERY[data.model]) {
    return `${data.type}_${
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      CUSTOM_MAP_MAINTAIN_OLD_CV_MODEL_QUERY[data.model]
    }_${startYear}`;
  }
  return `${data.type}_${data.model.replaceAll('-', '')}_${startYear}`;
};

export const getContentStackItemFromCvServiceMaintenancePageUrl = (
  url: string
) => {
  const splitStrings = url.split('_');
  // Correct URL should have more than 2 split strings
  if (splitStrings.length < 2) return undefined;

  const startYear = splitStrings[2];
  return {
    model_year_begin: parseInt(startYear),
  };
};
